<div>
  <div class="mat-h3">
    Buchhaltungs-Aggregationen
  </div>
  <ul>
    <li>
      <div class="mat-h3">
        Haben-Aggregation
      </div>
      <p>
        Diese Option fasst die Haben-Buchungssätze je Rechnung auf Basis von Konten und Kostenstellen zusammen
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Soll-Aggregation
      </div>
      <p>
        Diese Option fasst die Soll-Buchungssätze je Rechnung auf Basis von Konten und Kostenstellen zusammen
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Storno sofort anordnen
      </div>
      <p>
        Aktivieren Sie diese Option, um stornierte Rechnungen unmittelbar nach dem Storno automatisch anzuordnen
      </p>
    </li>
    <li>
      <div class="mat-h3">
        Vorname Nachname tauschen / Keine Rechnungsnummer im Buchungstext
      </div>
      <ul>
        <li>
          Standardmäßig sind die Buchungstexte für private Rechnungen im Format „Rechnungsnummer, Vorname Nachname“.
        </li>
        <li>
          Wenn nur die Option "Vorname Nachname tauschen" aktiviert ist, ändert sich das Format zu
          „Rechnungsnummer, Nachname, Vorname“.
        </li>
        <li>
          Wenn nur die Option "Keine Rechnungsnummer im Buchungstext" aktiviert ist, ändert sich das Format zu
          „Vorname Nachname“.
        </li>
        <li>
          Wenn beide Optionen aktiviert sind, ändert sich das Format zu „Nachname, Vorname“.
        </li>
        <li>
          Für andere Kostenträger lautet das Format standardmäßig „Rechnungsnummer, Name des Kostenträgers“ bzw.
          "Name des Kostenträgers", wenn die Option "Keine Rechnungsnummer im Buchungstext" aktiviert ist.
        </li>
      </ul>
    </li>
  </ul>
</div>
